import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'alert-small', 'IconAlertSmall', [["path",{"d":"M12 8v4","key":"svg-0"}],["path",{"d":"M12 16h.01","key":"svg-1"}]]);